import React from 'react';

const Expenses = () => {
  return (
    <div className="expenses">
      <h1>Expenses</h1>
      <div className="expenses-content">
        {/* Expenses content will go here */}
      </div>
    </div>
  );
};

export default Expenses; 